var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"card",attrs:{"draggable":true},on:{"dragstart":_vm.beginDrag,"dragover":function($event){$event.stopPropagation();}}},'div',attrs,false),on),[_vm._v(" "+_vm._s(_vm.name)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }